const categories = [
  {
    id: 0,
    title: 'All-Stars 2016',
    divisions: [
      {
        title: 'West',
        id: 1,
      },
      {
        title: 'East',
        id: 2,
      },
    ],
  },
  {
    id: 1,
    title: 'Tear Down This Wall',
    divisions: [
      {
        title: 'North',
        id: 1,
      },
      {
        title: 'South',
        id: 2,
      },
    ],
    text: 'If we put the southern-most 15 teams in a "Southern Conference," only the Hawks, Hornets, Magic and Heat would switch sides. Portland, Minnesota, Utah and Denver would play the other incumbent Eastern Conference teams. This season, a north/south alignment would still likely yield a Warriors-Spurs conference final matchup and a Cavs-Warriors final. Still, who wouldn’t want to buy an NBA North/South All-Star jersey?',
    image: 'assets/image/infographic/Bleacher-Report-Infographic-Sketches-01.png',
  },
  {
    id: 2,
    title: 'Origin Stories',
    divisions: [
      {
        title: 'East Kids',
        id: 1,
      },
      {
        title: 'West Kids',
        id: 2,
      },
    ],
    text: 'This year\'s All-Star Game will be held in Toronto, but it was born in Los Angeles. A quarter of the 2016 cast—six of 24 players—hail from the greater Los Angeles area: Klay Thompson, DeMar DeRozan, James Harden, Kawhi Leonard, Russell Westbrook and Paul George. But that doesn\'t mean the West has it won: half of our All-Stars were born in Eastern Conference cities.',
    image: 'assets/image/infographic/Bleacher-Report-Infographic-Sketches-02.png',
  },
  {
    id: 3,
    title: 'Going Global',
    divisions: [
      {
        title: 'USA',
        id: 1,
      },
      {
        title: 'the World',
        id: 2,
      },
    ],
    text: 'In quantity, the international basketball revolution is very much a thing. For two straight seasons, 100-plus international players (from 37 countries) made NBA rosters on opening night, out of a total of 446 players. That\'s a lot, especially when you consider only 45 internationals played in 2001, and only 21 in 1990-91. But in terms of quality, America’s stars still shine brighter. This year’s All-Star Game features only one international player, Spain’s Pau Gasol, who was controversially selected to replace injured teammate Jimmy Butler.',
    image: 'assets/image/infographic/Bleacher-Report-Infographic-Sketches-03.png',
  },
  {
    id: 4,
    title: 'Market Rate',
    divisions: [
      {
        title: 'Supersized Cities',
        id: 1,
      },
      {
        title: 'the Rest',
        id: 2,
      },
    ],
    text: 'There\'s an archaic notion that popularity and market size are directly correlated in the NBA. Um, no. This year, six of the 10 players voted in as starters—a vote that amounts to a popularity contest—play in cities outside the top 15 media markets. More than ever, the NBA is a meritocracy where the elite producers are loved, and playing in big markets only means more headaches when things go wrong.',
  },
  {
    id: 5,
    title: 'The Height Fight',
    divisions: [
      {
        title: 'Small Ball',
        id: 1,
      },
      {
        title: 'Big Ball',
        id: 2,
      },
    ],
    text: 'Only a handful of NBA players invite the "hey, if that guy can do it, why not me!?" response from casual fans. Incidentally, many of those players happen to be NBA All-Stars this year—a truly remarkable phenomenon in a sport where 6\'6" point guards are all the rage. World-class athleticism aside, All-Stars like Steph Curry (6\'3"), Kyle Lowry (6\'0"), Chris Paul (6\'0") and Isaiah Thomas (5\'9") look like normal humans relative to their monstrous counterparts.',
    image: 'assets/image/infographic/Bleacher-Report-Infographic-Sketches-04.png',
  },
  {
    id: 6,
    title: 'Battle for the Ages',
    divisions: [
      {
        title: '20-somethings',
        id: 1,
      },
      {
        title: '30-somethings',
        id: 2,
      },
    ],
    text: 'A published study from 2011 on NBA production vs. age revealed players typically peak at 26, but "once the player passes 30, the decline becomes steeper and steeper." As the paper\'s author David Berri noted for Vice, "once players reach their 30th birthdays, they start to curdle like milk." But maybe things are improving for the NBA\'s elder statesmen—this year, nine (!) All-Stars are north of 30.',
    image: 'assets/image/infographic/Bleacher-Report-Infographic-Sketches-05.png',
  },
  {
    id: 7,
    title: 'Time of Departure',
    divisions: [
      {
        title: 'ASAPs',
        id: 1,
      },
      {
        title: 'Late Bloomers',
        id: 2,
      },
    ],
    text: 'If you\'re good enough to get drafted in the first round, there\'s no sense in waiting. Now, more than ever, as Bleacher Report\'s C.J. Moore notes: "Last year, a record 13 one-and-done freshmen went in the first round, and the number of freshmen leaving has been trending upward." As it stands now, Draft Express projects 12 freshmen as first-round picks.',
  },
  {
    id: 8,
    title: 'Circle of Champions',
    divisions: [
      {
        title: 'Ringz',
        id: 1,
      },
      {
        title: 'No Ringz',
        id: 2,
      },
    ],
    text: 'The last four NBA championship teams are well-represented in this year\'s All-Star Game, including the “Big 3\'s” from last year\'s Golden State Warriors and the 2012-13 back-to-back champion Miami Heat. Kawhi Leonard is the lone Spur with a championship ring at this year\'s All-Star Game, which feels weird and dirty. Kobe Bryant loses the rings vs. the field battle: 13-5.',
    image: 'assets/image/infographic/Bleacher-Report-Infographic-Sketches-06.png',
  },
  {
    id: 9,
    title: 'The Money Game',
    divisions: [
      {
        title: 'High Rollers',
        id: 1,
      },
      {
        title: 'Value Buys',
        id: 2,
      },
    ],
    text: 'Let us take a moment to recall Stephen Curry—the reigning MVP and virtual 2016 MVP lock—will earn $11 million in salary this year. By contrast, JaVale McGee will earn $1 million more this season. It begs the question, in a world without max contracts, what would Curry be worth on the open market?',
    /* image: 'assets/image/infographic/Bleacher-Report-Infographic-Sketches-07.png', */
  },
  {
    id: 10,
    title: 'Battle of the Brands',
    divisions: [
      {
        title: 'Nike',
        id: 1,
      },
      {
        title: 'The World',
        id: 2,
      },
    ],
    text: '',
    image: 'assets/image/infographic/Bleacher-Report-Infographic-Sketches-08.png',
  },
  {
    id: 11,
    title: 'Getting Defensive',
    divisions: [
      {
        title: 'Pluses',
        id: 1,
      },
      {
        title: 'Minuses',
        id: 2,
      },
    ],
    text: 'It’s public-shaming time! Using the super-reliable Defensive Box Plus-Minus metric to evaluate defensive contributions, we identified six All-Stars who added negative value to their teams, defensively: James Harden, DeMar Derozan, Isaiah Thomas, Carmelo Anthony, Klay Thompson and Kobe Bryant. Anyone who’s followed the Lakers this year knows that Kobe Bryant isn’t the 12-time All-Defensive player of yesteryear. But we were surprised to see Klay Thompson, heralded as one of the league’s best two-way wings now, with a negative defensive mark relative to his peers.',
  },
];

export default categories;
